import gql from 'graphql-tag'

export const SET_USER_SETTINGS = gql`
  mutation($defaultProjectId: String, $favoriteProjectIds: [String]!) {
    setUserSettings(defaultProjectId: $defaultProjectId, favoriteProjectIds: $favoriteProjectIds)
  }
`
